import { render, staticRenderFns } from "./ZlifePetDemo.vue?vue&type=template&id=7735191a&scoped=true"
import script from "./ZlifePetDemo.vue?vue&type=script&lang=js"
export * from "./ZlifePetDemo.vue?vue&type=script&lang=js"
import style0 from "./ZlifePetDemo.vue?vue&type=style&index=0&id=7735191a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7735191a",
  null
  
)

export default component.exports